import React from "react";
import { withRouter } from "react-router-dom";
import { InputElement } from "../../shared/FormElements";

const NewsLetter = props => {
  const newsLetterStructure = props.form.map((value, index) => (
    <InputElement
      key={value + index}
      name={value.id}
      type={value.config.type}
      class="col-8"
      label={value.config.label}
      required={value.config.validation.require}
      value={value.config.value}
      onChangeHandler={props.onChangeHandler}
      formName={props.formName}
      onBlurHandler={props.onBlurHandler}
      errorMsg={value.config.errorMsg}
      valid={value.config.valid}
      maxLength={value.config.maxLength}
      placeholder={value.config.placeholder ? value.config.placeholder : ""}
      noLabel={value.config.noLabel ? value.config.noLabel : false}
    />
  ));
  return (
    <React.Fragment>
      <div className="row no-gutter subscribeSection">
        <div className="col-12">
          <h4>Sign up for The COB daily newsletter</h4>
          <p>The stuff you need to know about the day in business, finance and startups.</p>
        </div>
        <div className="col-8">
          {props.errorMessage && <p className="error">{props.errorMessage}</p>}
          {props.successMessage && (
            <p className="success">{props.successMessage}</p>
          )}
        </div>
        {newsLetterStructure}
        <div className="col-4">
          <button
            className="btn subscribe-btn"
            disabled={props.sucessState ? "disabled" : ""}
            onClick={() => props.sucessHandler(props.formName)}
          >
            SUBSCRIBE
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(NewsLetter);
